import {
  userStatus,
  envConfig,
  EncryptMe
} from '../_helpers';

export const channelService = {
  create,
  update
}

const user = userStatus();

async function create(data) {
  const encrypted = await EncryptMe(data);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/channel/create`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function update(data) {
  const encrypted = await EncryptMe(data);

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/channel/update`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}